var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartialIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9152_15545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14551 2.62488C8.44649 2.6251 8.6875 2.86681 8.6875 3.16785V9.31628H14.8369C15.1345 9.31652 15.3789 9.56158 15.3789 9.85925C15.3787 13.8469 12.1332 17.0924 8.14551 17.0927C4.15766 17.0927 0.911358 13.8471 0.911133 9.85925C0.911133 5.87126 4.15752 2.62488 8.14551 2.62488ZM7.60254 3.73523C4.4642 4.00955 1.99609 6.65174 1.99609 9.85925C1.99632 13.2481 4.75665 16.0077 8.14551 16.0077C11.3529 16.0075 13.9943 13.5395 14.2686 10.4012H8.14551C7.84447 10.4012 7.60276 10.1602 7.60254 9.85925V3.73523Z",
    fill: "#4A8DF2",
    stroke: "#4A8DF2",
    strokeWidth: 0.177862
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86035 0.907593C11.9358 0.907705 13.9097 1.79904 15.2842 3.35388C16.4444 4.67062 17.0869 6.3619 17.0938 8.11755V8.14197C17.0935 8.44281 16.8526 8.68374 16.5518 8.68396H9.86035C9.55931 8.68396 9.3176 8.44295 9.31738 8.14197V1.45056C9.31738 1.14939 9.55918 0.907593 9.86035 0.907593ZM10.4023 7.60193H15.9834C15.8663 6.2986 15.3417 5.06266 14.4688 4.07654H14.4678C13.4223 2.89156 11.9632 2.15972 10.4023 2.02185V7.60193Z",
    fill: "#4A8DF2",
    stroke: "#4A8DF2",
    strokeWidth: 0.177862
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9152_15545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialIcon);
export default __webpack_public_path__ + "static/media/PartialIcon.8a1db9bd63b4bea32294f9588f2d3dbe.svg";
export { ForwardRef as ReactComponent };